import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {mediasTyped} from '../../../utils/media';
import {Card, Eyebrow, SectionHead} from '../../../_ui/_v3/primitives';

const MediaGridStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
`;

const MediaCardStyled = styled(Card)`
  overflow: hidden;
  height: 180px;
  img { width: 100%; height: 100%; object-fit: cover; }
`;

const MediasSection = ({site}) => {
  const {t} = useTranslation(['touristic-site']);
  const images = mediasTyped(site.medias || []).image || [];

  if (images.length === 0) {
    return null;
  }
  return (
    <>
      <SectionHead>
        <Eyebrow>{t('v3.eyebrow.medias')}</Eyebrow>
        <h2>{t('v3.section.medias')}</h2>
      </SectionHead>
      <MediaGridStyled>
        {images.map((media, index) => (
          <MediaCardStyled key={media.blob_id || index}>
            <img src={media.url} alt={media.filename || `media-${index}`} loading="lazy" decoding="async" />
          </MediaCardStyled>
        ))}
      </MediaGridStyled>
    </>
  );
};

export default MediasSection;
